module.exports = __webpack_public_path__ + "img/sales-support-icon.1983334b.svg";